import angular from 'angular';
import { URL_TERMS_OF_SERVICE } from 'common/state';

import TermsOfServiceComponent from './terms-of-service.cmpt';

export default angular
    .module('legal.scene.terms-of-service', [])
    .component(TermsOfServiceComponent.selector, TermsOfServiceComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('terms-of-service', {
        url: URL_TERMS_OF_SERVICE,
        component: TermsOfServiceComponent.selector
    });
}



// WEBPACK FOOTER //
// ./src/legal/scene/terms-of-service/index.js